import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringSelection from "csi/heading/StringSelection";
import locale from "csi/locale";
import reflection from "csi/reflection";
import ReflectionClass from "csi/reflection/ReflectionClass";
import Classes from "csi/store/Classes";
import Store from "dojo/store/api/Store";
import declare from "dojo/_base/declare";

// ProductColorSpec does not have an alias (BO), so it does not fit the logic below. This set should contain
// any classes that are target classes of views that do not have an alias and possibly a target of User Defaults.
const exceptionSet = new Set<string>([
	"ProductColorSpec",
	"MaterialType",
	"StyleType",
]);

function isValidUserDefaultTargetClass({ abstract, alias, isAbstractClassOfDomainClasses, isPrimaryClass, type }: ReflectionClass): boolean {
	if (exceptionSet.has(type)) {
		return true;
	}

	if (abstract && alias && isAbstractClassOfDomainClasses) {
		return true;
	}

	return !!alias && isPrimaryClass;
}

const UserDefaultTargetClassRenderer = declare(StringSelection, {

	/**
	 * return user default target class type and name
	 */
	formatValue(value: any, fmt: string): string {
		return locale.type(value);
	},

	/**
	 * return reflection class that contains both alias and domainClass
	 */
	getStore(ctx: Context, h: Heading, value: any, bAll: boolean = false): Store<object, object, object> {
		return Classes(
			reflection.getClasses(),
			isValidUserDefaultTargetClass,
			(rc: ReflectionClass, item: any) => {
				item.name += ` (${rc.type})`;
			},
		);
	},
});

export = UserDefaultTargetClassRenderer;